import axios from 'axios';
import { PROCESS_AUTOMATION_SERVICE_URL } from '../Common/Constant/API';
import { commonRequestHeaders } from '../Common/request/headers';

export const openRelease = async (key, priorityGroup) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/release-management/git-flow/release-opening`,
      null,
      {
        params: {
          key,
          priorityGroup,
        },
        headers: {
          ...commonRequestHeaders(),
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error during deployment:', error);
    throw error;
  }
};

export const closeRelease = async (key, priorityGroup) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/release-management/git-flow/release-closing`,
      null,
      {
        params: {
          key,
          priorityGroup,
        },
        headers: {
          ...commonRequestHeaders(),
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error during deployment:', error);
    throw error;
  }
};

export const openHotfix = async (key, priorityGroup) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/release-management/git-flow/hotfix-opening`,
      null,
      {
        params: {
          key,
          priorityGroup,
        },
        headers: {
          ...commonRequestHeaders(),
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error during deployment:', error);
    throw error;
  }
};

export const closeHotfix = async (key, priorityGroup) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/release-management/git-flow/hotfix-closing`,
      null,
      {
        params: {
          key,
          priorityGroup,
        },
        headers: {
          ...commonRequestHeaders(),
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error during deployment:', error);
    throw error;
  }
};

export const hotfixOpeningRollBack = async (key, priorityGroup) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/release-management/git-flow/rollback/hotfix-opening-rollback`,
      null,
      {
        params: {
          key,
          priorityGroup,
        },
        headers: {
          ...commonRequestHeaders(),
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error during deployment:', error);
    throw error;
  }
};

export const hotfixClosingRollBack = async (key, priorityGroup) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/release-management/git-flow/rollback/hotfix-closing-rollback`,
      null,
      {
        params: {
          key,
          priorityGroup,
        },
        headers: {
          ...commonRequestHeaders(),
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error during deployment:', error);
    throw error;
  }
};

export const releaseOpeningRollBack = async (key, priorityGroup) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/release-management/git-flow/rollback/release-opening-rollback`,
      null,
      {
        params: {
          key,
          priorityGroup,
        },
        headers: {
          ...commonRequestHeaders(),
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error during deployment:', error);
    throw error;
  }
};

export const releaseClosingRollBack = async (key, priorityGroup) => {
  try {
    const token = localStorage.getItem('token');

    const response = await axios.post(
      `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/release-management/git-flow/rollback/release-closing-rollback`,
      null,
      {
        params: {
          key,
          priorityGroup,
        },
        headers: {
          ...commonRequestHeaders(),
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    console.error('Error during deployment:', error);
    throw error;
  }
};
